// src/assets/components/Tooltip.jsx
import React, { useState } from "react";

/**
 * 공통 툴팁 컴포넌트
 *
 * props
 * - text: 표시할 텍스트
 * - selectable: true면 클릭 시 사라짐, false면 절대 안 사라짐
 * - positionClass: 위치(Tailwind class)
 * - width: 가로 크기(Tailwind class)
 * - height: 세로/높이용 추가 class (선택)
 */
const Tooltip = ({
  text,
  selectable = false,
  positionClass = "absolute left-1/2 -translate-x-1/2 bottom-[calc(100%+4px)]",
}) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const handleClick = () => {
    if (selectable) {
      setVisible(false);
    }
  };

  return (
    <div
      className={`${positionClass} flex flex-col items-center`}
      onClick={handleClick}
    >
      {/* 말풍선 본체 */}
      <div
        className={`
          text-center
          py-[4px] px-[8px]
          max-w-[256px] w-max
          rounded-[8px]
          bg-surface-dark-absolute-dimmed_80
          text-text-inverse text-c3
          whitespace-pre-line
        `}
      >
        {text}
      </div>

      {/* 아래 삼각형(꼬리) */}
      <div
        className="
          w-0 h-0
          border-x-[7px] border-x-transparent
          border-t-[7px] border-surface-dark-absolute-dimmed_80
        "
      />
    </div>
  );
};

export default Tooltip;
